<div class="eos-spinner-container">
  <mat-spinner></mat-spinner>
</div>
